/** localStorage key for the signed JWT from login / verify-2fa (Phase 2 passport). */
export const WIZTASKS_AUTH_TOKEN_KEY = 'wiztasks_auth_token';

/**
 * Decode JWT payload (middle segment) without verifying signature — UI gate only; API enforces auth.
 */
export function decodeJwtPayload(token: string): {
  global_role?: string;
  is_super_admin?: number | boolean;
  user_id?: number;
  exp?: number;
} | null {
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  const segment = parts[1];
  try {
    const b64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '==='.slice((b64.length + 3) % 4);
    const json = atob(padded);
    return JSON.parse(json) as {
      global_role?: string;
      is_super_admin?: number | boolean;
      user_id?: number;
      exp?: number;
    };
  } catch {
    return null;
  }
}
